import { takeEvery } from 'redux-saga/effects'
import {
  configConstants,
  leadConstants,
  scoreConstants,
  socketConstants
} from '../constants'

import { configLoadSaga } from './config.sagas'
import { scoreLoadSaga, scoreSaveSaga } from './score.sagas'
import {
  socketInitSaga,
  socketSubscribeSaga,
  socketUnsubscribeSaga,
  socketEmitSaga
} from './socket.sagas'
import { leadPatchSaga, leadSaveSaga } from './lead.sagas'

export function* watchConfig() {
  yield takeEvery(configConstants.CONFIG_LOAD, configLoadSaga)
}

export function* watchScore() {
  yield takeEvery(scoreConstants.SCORE_LOAD, scoreLoadSaga)
  yield takeEvery(scoreConstants.SCORE_SAVE, scoreSaveSaga)
}

export function* watchSocket() {
  yield takeEvery(socketConstants.SOCKET_INIT, socketInitSaga)
  yield takeEvery(socketConstants.SOCKET_SUBSCRIBE, socketSubscribeSaga)
  yield takeEvery(socketConstants.SOCKET_UNSUBSCRIBE, socketUnsubscribeSaga)
  yield takeEvery(socketConstants.SOCKET_EMIT, socketEmitSaga)
}

export function* watchLead() {
  yield takeEvery(leadConstants.LEAD_SAVE, leadSaveSaga)
  yield takeEvery(leadConstants.LEAD_PATCH, leadPatchSaga)
}
